module.exports = __webpack_public_path__ + "img/humas_color.3316bc13.png";